import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import BASE_URL from "../BaseUrl/apiConfig";

function ViewMessageLog(props) {
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [messageLog, setMessageLog] = useState(null);

  // Extract messageId from location state
  const messageId = props.location.state.messageId;

  useEffect(() => {
    fetchMessageLogByIdforView(messageId);
  }, [messageId]);

  const fetchMessageLogByIdforView = (messageId) => {
    fetch(`${BASE_URL}/api/Expense/GetMesaageLogByID?messageId=${messageId}`)
      .then((response) => response.json())
      .then((data) => {
        setMessageLog(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      <Navbar />
      <div className="cust-div">
        <div className="container mx-auto mt-8 p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold">Message Log Details</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={() => history.goBack()}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To All Message logs"
                ></i>
                Go Back
              </button>
            </div>
          </div>
          {messageLog ? (
            <div className="message-details">
              <hr className="my-4 border-t-2 border-gray-300" />
              <div className="message-sent-info" style={{ textAlign: "left" }}>
                <h2 className="text-2xl font-semibold">
                  {messageLog.recipientName}
                </h2>
              </div>
              <div className="message-content" style={{ textAlign: "left" }}>
                <p className="text-lg">{messageLog.description}</p>
              </div>
              <div className="message-sent-info">
                <p
                  className="text-base"
                  style={{ textAlign: "left", float: "left", width: "50%" }}
                >
                  <strong>Sent by:</strong> {messageLog.userName}
                </p>
                <p
                  className="text-base"
                  style={{ textAlign: "right", float: "right", width: "50%" }}
                >
                  <strong>Sent on:</strong>{" "}
                  {new Date(messageLog.messageDate).toLocaleDateString(
                    "en-GB",
                    {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: true,
                    }
                  )}
                </p>
                <div style={{ clear: "both" }}></div>
              </div>
              <div className="text-base" style={{ marginTop: "30px" }}>
                <div
                  className="text-base"
                  dangerouslySetInnerHTML={{ __html: messageLog.message }}
                />
              </div>
            </div>
          ) : (
            <div>Loading...</div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ViewMessageLog;
